export const getColorByRank = (rank: number) => {
  if (!rank) {
    return '#ccc'
  }
  switch (Number(rank || 0)) {
    case 0:
      return '#ccc'
    case 1: //Very poor
      return '#FF6578'
    case 2: //Poor
      return '#FF9B53'
    case 3: //Ok
      return '#F8DF5C'
    case 4: //Good
      return '#C4EB7B'
    case 5: //Very good
      return '#97ECC8'
  }
  return '#ccc'
}
